import { colors } from "../constants/colors.js";
import { getSingleColorWithGradient } from "../utils/chartColors.js";
const gradients = {
  default: {
    bottom: colors.black.white,
    top: colors.blaze[200],
    border: colors.blaze[600],
    color: colors.blaze[500]
  },
  green: {
    bottom: colors.black.white,
    top: colors.green[300],
    border: colors.green[600],
    color: colors.green[500]
  },
  blaze: getSingleColorWithGradient(colors.blaze),
  volt: getSingleColorWithGradient(colors.volt),
  gray: getSingleColorWithGradient(colors.black),
  blue: getSingleColorWithGradient(colors.blue),
  princess: {
    bottom: colors.blaze[200],
    top: colors.green[500],
    border: colors.green[500],
    color: colors.blaze[200]
  }
};
export {
  gradients as default
};
